// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {SchedulingExtendModuleLayout} from 'app_components/modules/schedulingExtend'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import SchedulingService from 'app_services/campus/academic/schedulingService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import {ICompanyUser} from 'app_types/admin/user/userTypes'
// @end

// @ADD Component types
interface ISchedulingExtendModuleProps {
  company?: ICompanyUser
  contact?: string
}
interface ISchedulingExtendModuleState {
  status: null | 'loading' | 'error'
  schedulingData: Array<any>
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SchedulingExtendModule extends Component<ISchedulingExtendModuleProps, ISchedulingExtendModuleState> {

  private schedulingService: SchedulingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISchedulingExtendModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      schedulingData: [],
      pagination: {
        page: 1,
        perPage: 20,
        total: 0,
      },
    }
    this.schedulingService = new SchedulingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchSchedulingExtendData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchSchedulingExtendData = async (params?: any) => {

    // TODO: Implementar filtros de fecha

    this.setState({
      status: 'loading',
      schedulingData: [],
    })

    const http_params: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
    }
    if (this.props.company?._id) {
      http_params['company'] = this.props.company?._id
    }

    if (this.props.contact) {
      http_params['contact'] = this.props.contact
    }

    if (params?.start_date) {
      http_params['start_date'] = params.start_date;
    }

    if (params?.end_date) {
      http_params['end_date'] = params.end_date;
    }

    const dataResponse = await this.schedulingService.fetchSchedulingExtendData(http_params, {showError: false})

    if (dataResponse) {
      let scheduling = []
      if (dataResponse.schedulings) {
        scheduling = dataResponse.schedulings.reduce((accum: Array<any>, element: any) => {
          accum.push(element)
          return accum
        }, [])
      }
      this.setState({
        schedulingData: scheduling,
        pagination: {
          total: dataResponse?.total_register,
          perPage: dataResponse?.nPerPage,
          page: dataResponse?.pageNumber,
        },
        status: null})
    } else {
      this.setState(({status: null}))
    }
  }

  onPageChange = async (page: number) => {
    this.fetchSchedulingExtendData({ page })
  }

  render() {
    return(
      <SchedulingExtendModuleLayout
        status={this.state.status}
        schedulingData={this.state.schedulingData}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        fetchSchedulingExtendData={this.fetchSchedulingExtendData}
      />
    )
  }
}

export default connect(mapStatesToProps)(SchedulingExtendModule)
